import { Density, Direction } from '@philips-emr/tws-constants';
import { ComponentAPI } from '@philips-emr/tws-core';
import { isEnumValid } from '@philips-emr/tws-utils';

class ValueListAPI extends ComponentAPI {

  getData(): object[] {
    return this.state.data;
  }

  setData(data: object[]): void {
    this.setState({ data });
  }

  setDirection(direction: Direction): void {
    if (!isEnumValid(Direction, direction)) {
      return;
    }

    this.setState({ direction });
  }

  getDirection(): Direction {
    return this.state.direction;
  }

  setDensity(density: Density): void {
    if (!isEnumValid(Density, density)) {
      return;
    }

    this.setState({ density });
  }

  getDensity(): Density {
    return this.state.density;
  }

}

export default ValueListAPI;
